import { AppState } from '../reducers';

export const selectTargetGroupsById = (groupId: string | undefined) => {
    return (state: AppState) =>
        groupId ? state.users.byTargetGroup[groupId] : {};
};
export const selectFetchingUsers = (state: AppState) =>
    state.users.fetchingUsers;
